'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/footer.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect,useRef } from "react";
import Loading from "./loading";
import ReCAPTCHA from 'react-google-recaptcha';
import GoogleMap from '@/app/components/googlemap';

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMzg=") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    contactUsPage {
      formTitle
      overviewCreativeHeading
      overviewHeading
    }
  }
  globalSettings {
    globalSettingsNew {
      openingHours
      smFacebook
      smInstagram
      tripadvisor
      googleMapUrl
      latitude
      longitude
      mapDescription
      mapTitle
    }
    globalSettingsNewSmtp {
      addressLine1
      contactEmail
      contactName
      hotlineNumber
    }
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function ContactUs() {

  const recaptchaRef = useRef();

  const apiKey = process.env.GOOGLE_MAP_KEY;
  const mapOptions = 'SEEN+Restaurant+%26+Bar+Bangkok';

  const deviceType = useDeviceType();

  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaValueVisible, setCaptchaValueVisible] = useState(false);
  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [overview_creative_heading, setOverviewCreativeHeading] = useState("");
  const [overview_heading, setOverviewHeading] = useState("");
  const [form_heading, setFormHeading] = useState("");

  const [phone_number, setPhoneNumber] = useState('');
  const [email_address, setEmailAddress] = useState('');
  const [main_address, setMainAddress] = useState('');
  const [opening_hours, setOpeningHours] = useState('');
  const [fb_link, setFbLink] = useState('');
  const [insta_link, setInstaLink] = useState('');
  const [advisor_link, setAdvisorLink] = useState('');

  const [latitue, setGoogleMapLat] = useState("");
  const [longtide, setGoogleMapLong] = useState("");
  const [map_title, setGoogleMapTitle] = useState("");
  const [map_desc, setGoogleMapDesc] = useState("");
  const [map_url, setGoogleMapUrl] = useState("");

  const [success_msg, setSuccessMesseage] = useState(null);
  const [error_messege, setErrorMessege] = useState(null);
  const [is_loading, setIsLoading] = useState(false);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  const [formData, setFormData] = useState({
    title: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    subject: '',
    message: '',
    consent: false,
    type: 'Contact Us',
  });

  const [errors, setErrors] = useState({});

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({
      ...errors,
      [name]: '',
    });
  };

  const handleFocus = (name, type) => {
    setInputTypes((prevTypes) => ({
      ...prevTypes,
      [name]: type,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    const phoneRegex = /^[\d\s()+-]+$/;
    if (!formData.title) newErrors.title = 'Title is required';
    if (!formData.firstName) newErrors.firstName = 'First name is required';
    if (!formData.lastName) newErrors.lastName = 'Last name is required';
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!phoneRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Phone number is invalid';
    }
    if (!formData.emailAddress) {
      newErrors.emailAddress = 'Email address is required';
    } else if (!validateEmail(formData.emailAddress)) {
      newErrors.emailAddress = 'Email address is invalid';
    }
    if (!formData.subject) newErrors.subject = 'Subject is required';
    if (!formData.message) newErrors.message = 'Message is required';
    if (!formData.consent) newErrors.consent = 'Consent is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length === 0) {

      if (!captchaValue) {
        setErrorMessege('Please verify the reCAPTCHA.');
        return;
      }

      // if (!captchaValue) {
      //   setErrorMessege('Please verify the reCAPTCHA.');
      //   return;
      // }else{
      //   setErrorMessege(null);
        
      //   const response = await fetch('/api/submit', {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify({recaptchaToken: captchaValue })
      //   });
  
      //   const result = await response.json();
      //   if(result.message !== true){
      //     setErrorMessege('Invalid reCAPTCHA.');
      //     return;
      //   }
      // }

      // if (!captchaValue) {
      //   setErrorMessege('Please verify the reCAPTCHA.');
      //   return;
      // } else {
      //   setErrorMessege(null);

      //   const verificationUrl = `https://www.google.com/recaptcha/api/siteverify?secret=${process.env.RECAPTCHA_SECRET_KEY}&response=${captchaValue}`;
  
      //   const response = await fetch(verificationUrl, {
      //     method: 'POST',
      //   });
  
      //   const data = await response.json();
  
      //   if (data.success) {
      //     console.log("reCAPTCHA verified successfully!");
      //   } else {
      //     setErrorMessege('Invalid reCAPTCHA.');
      //   }
      // }

      setIsLoading(true);
      const response = await fetch(process.env.FROM_SUBMIT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData, recaptchaToken: captchaValue }),
        httpsAgent: agent
      });

      if (response.ok) {
        setIsLoading(false);
        setErrorMessege(null);
        setCaptchaValue(null);
        recaptchaRef.current.reset(); 
        setSuccessMesseage('Form submitted successfully');
        setFormData({
          title: '',
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailAddress: '',
          subject: '',
          message: '',
          consent: false,
          type: 'Contact Us',
        });

        setTimeout(() => {
          setSuccessMesseage(null);
        }, 10000);

      } else {
        setIsLoading(false);
        setSuccessMesseage(null);
        setCaptchaValue(null);
        recaptchaRef.current.reset(); 
        setErrorMessege('Failed to submit form.');

        setTimeout(() => {
          setErrorMessege(null);
        }, 3000);
      }
    } else {
      setErrors(formErrors);
      recaptchaRef.current.reset(); 
    }
  };

  useEffect( () => {
    if(captchaValue){
      setErrorMessege(null);
    }
  }, [captchaValue]);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();
      if(page){
        //console.log(page);
        setPageData(page.pageData);
        if(page.pageData){

          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }


          if(page.pageData.contactUsPage){
            if(page.pageData.contactUsPage.overviewCreativeHeading){
              setOverviewCreativeHeading(page.pageData.contactUsPage.overviewCreativeHeading);
            }
            if(page.pageData.contactUsPage.overviewHeading){
              setOverviewHeading(page.pageData.contactUsPage.overviewHeading);
            }
            if(page.pageData.contactUsPage.formTitle){
              setFormHeading(page.pageData.contactUsPage.formTitle);
            }
          }

          
        }
        if(page.globalSettings){
          if(page.globalSettings.globalSettingsNew){
            if (page.globalSettings.globalSettingsNew.openingHours) {
              setOpeningHours(page.globalSettings.globalSettingsNew.openingHours);
            }
            if (page.globalSettings.globalSettingsNew.smFacebook) {
              setFbLink(page.globalSettings.globalSettingsNew.smFacebook);
            }
            if (page.globalSettings.globalSettingsNew.smInstagram) {
              setInstaLink(page.globalSettings.globalSettingsNew.smInstagram);
            }
            if (page.globalSettings.globalSettingsNew.tripadvisor) {
              setAdvisorLink(page.globalSettings.globalSettingsNew.tripadvisor);
            }
            if (page.globalSettings.globalSettingsNew.latitude) {
              setGoogleMapLat(page.globalSettings.globalSettingsNew.latitude);
            }
            if (page.globalSettings.globalSettingsNew.longitude) {
              setGoogleMapLong(page.globalSettings.globalSettingsNew.longitude);
            }
            if (page.globalSettings.globalSettingsNew.mapDescription) {
              setGoogleMapDesc(page.globalSettings.globalSettingsNew.mapDescription);
            }
            if (page.globalSettings.globalSettingsNew.mapTitle) {
              setGoogleMapTitle(page.globalSettings.globalSettingsNew.mapTitle);
            }
            if (page.globalSettings.globalSettingsNew.googleMapUrl) {
              setGoogleMapUrl(page.globalSettings.globalSettingsNew.googleMapUrl);
            }
          }
          if(page.globalSettings.globalSettingsNewSmtp){
            if (page.globalSettings.globalSettingsNewSmtp.addressLine1) {
              setMainAddress(page.globalSettings.globalSettingsNewSmtp.addressLine1);
            }
            if (page.globalSettings.globalSettingsNewSmtp.contactEmail) {
              setEmailAddress(page.globalSettings.globalSettingsNewSmtp.contactEmail);
            }
            if (page.globalSettings.globalSettingsNewSmtp.hotlineNumber) {
              setPhoneNumber(page.globalSettings.globalSettingsNewSmtp.hotlineNumber);
            }
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);


  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])

  if (pre_loader_enabled) {
    return <Loading />;
  }

  return (
    <>
      {page_banner_sliders && page_banner_sliders.length !== 0 &&(
      <section className="inner-banner position-relative">
        <Carousel fade className='page-inner-carousel'>
        {page_banner_sliders.map((banner_img, index) => {

          let imgurl = '';

          if(banner_img.desktopImage){
            if(banner_img.desktopImage.node){
              if(banner_img.desktopImage.node.mediaItemUrl){
                imgurl = banner_img.desktopImage.node.mediaItemUrl;
              }
            }
          }

          return(
          <Carousel.Item key={index}>
            <Image  
              className={styles.banner_section_main_img}
              src={imgurl}
              width={deviceType !== "mobile" ? 1920 : 400}
              height={deviceType !== "mobile" ? 1080 : 800}
              alt="Banner Image"
              priority
              quality={deviceType !== "mobile" ? 50 : 80}
            />
          </Carousel.Item>
          );}
          )}
        </Carousel>
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--yellow'>{page_banner_text}</h2>
        </div>
      </section>
      )}
      {page_banner_sliders && page_banner_sliders.length === 0 &&(
      <section className="bg-dark-green inner-banner-text-wrap position-relative">
        <div className='inner-banner-text z-top'>
          <h2 className='all-caps section-heading-large section-heading--yellow m-0'>{page_banner_text}</h2>
        </div>
      </section>
      )}
      <section className="bg-dark-green green-mesh section-padding-top section-padding-bottom z-top">
        <div className="middle-wrap d-flex z-top flex-wrap justify-content-between">
          <div className="half-div contact-details">
            <h6 className="creative-heading-small tab-text-left creative-heading--white">
            {overview_creative_heading}
            </h6>
            <h1
            className="section-heading section-heading--yellow tab-text-left heading-padding">
              {overview_heading}
            </h1> 
            <ul className="contact-ul">
              <li>
                <Image  
                  src="/pin.png"
                  width={50}
                  height={50}
                  alt="Down arrow"
                />
                <div className="paragraph paragraph--white m-0 tab-text-left">{main_address}</div>
              </li>
              <li>
                <Image  
                  src="/emal.png"
                  width={50}
                  height={50}
                  alt="Down arrow"
                />
                <a  className="paragraph paragraph--white m-0" href={`mailto:${email_address}`}>{email_address}</a>
              </li>
              <li>
                <Image  
                  src="/call.png"
                  width={50}
                  height={50}
                  alt="Down arrow"
                />
                <a  className="paragraph paragraph--white m-0" href={`tel:${phone_number}`}>{phone_number}</a>
              </li>
            </ul>
            <h6 className="paragraph paragraph--yellow m-0 tab-text-left">SEEN&apos;ss Opening Hours</h6>
            <p className="paragraph paragraph--white m-0 heading-padding tab-text-left">{opening_hours}</p>
            <ul className={`${styles.footer_social} footer-social-con`}>
              <li>
                <a target="_blank" href={fb_link}>
                  <Image   src="/fb.png" width={50} height={50} alt="Facebook Icon" />
                </a>
              </li>
              <li>
                <a target="_blank" href={insta_link}>
                  <Image  
                    src="/insta.png"
                    width={50}
                    height={50}
                    alt="Instagram Icon"
                  />
                </a>
              </li>
              <li>
                <a target="_blank" href={advisor_link}>
                  <Image  
                    src="/advi.png"
                    width={50}
                    height={50}
                    alt="Advisor Icon"
                  />
                </a>
              </li>
            </ul>
          </div>
          <div className="half-div contact-map">
            <div className="the_content_div google_map_emb map-details">
              <GoogleMap 
              title={map_title}
              desc={map_desc}
              url={map_url}
              long={longtide}
              lat={latitue}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="cream-mesh bg-cream section-padding-top section-padding-bottom z-top">
        <div className="lsmall-wrap z-top">
           <h2
          className="section-heading section-heading--black text-center heading-padding">
            {form_heading}
          </h2> 
          <form className="form-wrap" onSubmit={handleSubmit}>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-half d-flex flex-wrap justify-content-between">
                <div className="dropdown-div">
                  <label>Title<span>*</span></label>
                  <select name="title" value={formData.title} onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                  </select>
                  {errors.title && <span className="error-msg">{errors.title}</span>}
                </div>
                <div className="input-div">
                  <label>First Name<span>*</span></label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter your first name here"
                  />
                  {errors.firstName && <span className="error-msg">{errors.firstName}</span>}
                </div>
              </div>
              <div className="form-col-half">
                <label>Last Name<span>*</span></label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter your last name here"
                />
                {errors.lastName && <span className="error-msg">{errors.lastName}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-half">
                <label>Phone Number<span>*</span></label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter your phone number here"
                />
                {errors.phoneNumber && <span className="error-msg">{errors.phoneNumber}</span>}
              </div>
              <div className="form-col-half">
                <label>Email Address<span>*</span></label>
                <input
                  type="email"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleChange}
                  placeholder="Enter your email address here"
                />
                {errors.emailAddress && <span className="error-msg">{errors.emailAddress}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-full">
                <label>Subject<span>*</span></label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Enter your subject here"
                />
                {errors.subject && <span className="error-msg">{errors.subject}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-full heading-padding">
                <label>Message<span>*</span></label>
                <input
                  type="text"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your message here"
                />
                {errors.message && <span className="error-msg">{errors.message}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-full">
                <h6 className="paragraph-small paragraph--black para-bold">GDPR Compliance</h6>
                <p className="paragraph-small paragraph--black">By giving your confirmation you explicitly give consent for us to store and use this information to service your requests. If you do not consent we will not store any personal information and will only send an email with the relevant details in order to service your requests.</p>
                <label className="d-flex checked-lable">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                  />
                  <p className="paragraph-small paragraph--black m-0">I confirm I have read and given consent for the above.</p>
                </label>
                {errors.consent && <span className="error-msg">{errors.consent}</span>}
                <p className="paragraph-xsmall paragraph--black form-para">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
                <label className="ex-small"><span>*</span>required fields</label>
              </div>
            </div>
            <div className="recaptcha-wrap">
              <ReCAPTCHA
                ref={recaptchaRef} 
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
              />
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between p-0">
              <div className="form-col-full d-flex aling-items-center">
                <button disabled={is_loading} type="submit" className="reserve-btn reserve-btn--yellow">Reserve Now</button>
                {is_loading &&(
                <Image  
                  className="loader"
                  src="/loader.gif"
                  width={50}
                  height={50}
                  alt="corner border"
                />
                )}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between p-0">
              <div className="form-col-full">
                {success_msg &&(
                  <div className="succes-msg-div">{success_msg}</div>
                )}
                {error_messege &&(
                  <div className="error-msg-div">{error_messege}</div>
                )}
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  )
}
